import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { environment } from "src/environments/environment";
import { DbTemplate, Template, TemplateListItem } from './template.model';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {
  
  constructor(
    private http: HttpService,
  ) { }


  async getTemplateList(departmentId: string): Promise<TemplateListItem[]> {
      return await this.http.get<TemplateListItem[]>(`${environment.adminConfig.apiUri}/template/list/${departmentId}`);
   }

  async getAvailableTemplates(): Promise<DbTemplate[]> {
    return await this.http.get<DbTemplate[]>(`${environment.adminConfig.apiUri}/template/availabletemplates`);
  }

  async createDbTemplate(departmentId: string, dbTemplateId: string): Promise<string> {
    return await this.http.post(`${environment.adminConfig.apiUri}/template/create`, { DbTemplateId: dbTemplateId, DepartmentId: departmentId});
  }

  async getTemplate(templateid: string): Promise<Template> {
    return await this.http.get(`${environment.adminConfig.apiUri}/template/${templateid}`);
  }
  
  async updateTemplate(template: Template): Promise<boolean> {
    return await this.http.put(`${environment.adminConfig.apiUri}/template`, template);
  }

  async deleteTemplate(templateid: string): Promise<boolean> {
    return await this.http.delete(`${environment.adminConfig.apiUri}/template/${templateid}`);
  }
}
